import { useEffect, useState } from "react";
import { X, Pin, Info, AlertTriangle, AlertOctagon } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const META = {
  information: { icon: Info, cls: "border-accent/40 bg-accent/10", iconCls: "text-accent" },
  warning: { icon: AlertTriangle, cls: "border-warning/40 bg-warning/10", iconCls: "text-warning" },
  important: { icon: AlertOctagon, cls: "border-destructive/50 bg-destructive/10", iconCls: "text-destructive" },
};

export default function AnnouncementsBanner() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try { const { data } = await api.get("/announcements/active"); setItems(data || []); }
    catch { /* silent — dashboard should still render */ }
  };
  useEffect(() => { load(); }, []);

  const dismiss = async (a) => {
    setItems((prev) => prev.filter((x) => x.id !== a.id));
    try { await api.post(`/announcements/${a.id}/dismiss`); } catch { /* ignore */ }
  };

  if (!items.length) return null;

  return (
    <div className="space-y-3 mb-6" data-testid="announcements-banner">
      {items.map((a) => {
        const meta = META[a.priority] || META.information;
        const Icon = meta.icon;
        return (
          <div key={a.id} className={`relative rounded-lg border p-4 pr-10 ${meta.cls}`} data-testid={`announcement-card-${a.id}`}>
            <div className="flex items-start gap-3">
              <Icon className={`h-5 w-5 mt-0.5 shrink-0 ${meta.iconCls}`} aria-hidden="true" />
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h4 className="font-display font-semibold">{a.title}</h4>
                  {a.pinned && (
                    <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold text-primary">
                      <Pin className="h-3 w-3" /> Pinned
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground mt-1 whitespace-pre-wrap">{a.message}</p>
              </div>
            </div>
            {a.dismissible && (
              <Button
                variant="ghost" size="icon"
                className="absolute top-2 right-2 h-7 w-7 text-muted-foreground hover:text-foreground"
                onClick={() => dismiss(a)}
                data-testid={`announcement-dismiss-${a.id}`}
              >
                <X className="h-4 w-4" />
                <span className="sr-only">Dismiss</span>
              </Button>
            )}
          </div>
        );
      })}
    </div>
  );
}
